import React from "react";

const CardDemo = () => {
  return (
    <div className="w-1/2 flex flex-col items-start justify-start gap-8 p-4 ">
      {/* First Card */}
      <div
        className="w-3/4 max-h-[500px] overflow-hidden rounded-2xl shadow-lg flex flex-col justify-between p-4 bg-white border-grey"
        // style={{ backgroundImage: `url(${background})` }}
      >
        <div className="text-blue-900 ">
          <h1 className="text-2xl font-bold">About Me</h1>
          <p className="mt-4">
            Welcome to my practice. I am Maria Mizamidou, a dedicated
            psychotherapist with over 15 years of experience in the field of
            mental health. My professional journey has been deeply committed to
            supporting individuals as they navigate the complexities of
            emotional challenges and relationship dynamics in various aspects of
            life—whether with family, friends, partners, or colleagues. If you
            often find yourself trapped in repetitive patterns, feeling
            perplexed by your emotions and actions, I am here to assist you. My
            approach focuses on helping you understand and transform these
            patterns, guiding you toward cultivating healthier, more rewarding
            relationships. The goal is to enhance your overall happiness and
            quality of life. In addition to relationship dynamics, my practice
            is also devoted to aiding those struggling with anxiety, depression,
            and the impacts of trauma. Through a compassionate and tailored
            therapeutic approach, I strive to help you heal and grow, empowering
            you to lead a more fulfilling life. Together, we can explore the
            root causes of your struggles, providing you with the insights and
            tools needed to make lasting changes. I look forward to being a part
            of your journey toward personal transformation and well-being.
          </p>
          <h2 className="text-2xl font-bold mt-4">
            Psychotherapeutic Approaches
          </h2>
          <p className="mt-4">
            As a psychotherapist, I integrate a variety of theoretical
            frameworks to offer a holistic and individualized approach to
            therapy. My work is primarily grounded in Gestalt therapy, which
            focuses on the present moment, awareness, and phenomenology, helping
            clients explore their experiences in real-time. I also place
            significant emphasis on attachment theory, which allows us to delve
            into past relational dynamics and their influence on current
            patterns, fostering deeper self-awareness and healing.
          </p>
        </div>
      </div>

      {/* Second Card */}
      <div
        className="w-3/4 max-h-[500px] overflow-hidden rounded-2xl shadow-lg flex flex-col justify-between p-4  bg-white border-grey"
        // style={{ backgroundImage: `url(${background})` }}
      >
        <div className="text-blue-900">
          <h1 className="text-2xl font-bold">My Background</h1>
          <p className="mt-4">
            I've dedicated my career to understanding the complexity of human
            behavior and mental health. My additional training in data science
            allows me to incorporate analytical skills into my therapeutic
            practices, enhancing my ability to understand and predict behavioral
            patterns.
          </p>
          <h2 className="text-2xl font-bold mt-4">Areas of Focus</h2>
          <p className="mt-4">
            My areas of focus include anxiety disorders, relationship issues,
            and personal growth. Through a blend of therapeutic techniques, I
            strive to empower my clients to achieve their personal and
            relational goals.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardDemo;
